import {applyResultCart} from "@Common/logic/checkout/common/apply-result-cart";
import {setNestedValue}  from "@Common/utils/arr-path";
import {cascadeFind}     from "@Common/utils/cascade";
import {chain}           from "@Common/utils/fs";

export const setStoreCredits = (id, {apis}) => ({
    action: async (cart) => {
        return {
            change: applyResultCart(await apis.next.cart.updateCart(chain(
                {cartId: cart.cartId},
                (_) => (
                    setNestedValue(_, ["credits", "storeCredits"], [{
                        id,
                        storeCreditName: cascadeFind(cart.items, `[*].billingAvailable.storecredit[*]`, (sc) => sc.id === id && sc.name),
                    }])
                ),
            ))),
        };
    },
});
